import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-therapies',
  templateUrl: './therapies.component.html',
  styleUrls: ['./therapies.component.scss']
})
export class TherapiesComponent implements OnInit {

  @Input() istherapies: boolean = false;
  @Input() istreatmentphilosopy: boolean = false;
  @Input() istreatments: boolean = false;

  constructor(private route: ActivatedRoute, private router: Router) { }
  section: string = '';
  ngOnInit(): void {
    this.route.url.subscribe(() => {
      this.route.firstChild?.data.subscribe(data => {
        if (data['section']) {
          this.section = data['section'];
        }
      });
    });
  }

}
